import { Dictionary } from '@/dictionary/Dictionary'
import i18n from '@/i18n'

const senderContactInfoSourceDict: Array<Dictionary> = []

for (const code of ['manager', 'site', 'store']) {
    senderContactInfoSourceDict.push({ code: code, name: i18n.t(`dictionary.senderContactInfoSource.${code}`).toString() })
}

export { senderContactInfoSourceDict }
